<template>
    <div class="fm-container" v-if="availability_data">
        <div style="font-size: 14px; font-weight: bold; margin-bottom: 10px; background-color: #FDD835; padding: 10px;">
            Availability for: {{ product_sku}} 
        </div>

        <table style="width: 100%;">
            <thead>
                <tr style="background-color: black; color: white;">
                    <td class="ipt_tdhr">
                        Location
                    </td class="ipt_tdhr">

                    <!-- <td class="ipt_tdhr">
                        Sublocation
                    </td class="ipt_tdhr">
 -->
                    <td class="ipt_tdhr">
                        Reserved
                    </td>

                    <td class="ipt_tdhr">
                        Available
                    </td>

                    <td class="ipt_tdhr">
                        Upcoming
                    </td>
                </tr>
            </thead>

            <tbody>
                <tr v-for="availability in availability_data">
                    <td class="ipt_tdr" style="font-size: 15px;">
                        {{ locationsdict[availability.location_id] }}
                         / 
                        {{ sublocationsdict[availability.sublocation_id] }}
                    </td>
                    <td class="ipt_tdr" style="font-size: 15px;">
                        {{ availability.nreserved }}
                    </td>
                    <td class="ipt_tdr" style="font-size: 15px;">
                        {{ availability.navailable }}
                    </td>

                    <td class="ipt_tdr" style="font-size: 15px;">
                        <div v-if="availability.upcoming">
                            <div v-for="uc in availability.upcoming" style="text-align: left; padding: 5px; background: #c9ffc9; margin-bottom: 10px; ">
                                <div style="font-size: 12px;">{{ uc.eta }} : {{ uc.quantity }}</div>
                                <div style="font-size: 12px;">({{ uc.po_number }})</div>
                               
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

<!--     <div v-if="category_data">
        <div v-if="edit === false">
            <b-card :title="category_data.category" sub-title=" ">

                <b-card-text>
                    <b>ID:</b> {{ category_data.id }}
                </b-card-text>

                <b-card-text>
                    <b>Name:</b> {{ category_data.category }}
                </b-card-text>

                <b-card-text>
                    <b>Time Added:</b> {{ category_data.ts }}
                </b-card-text>

                <b-card-text>
                    <b>Description:</b> {{ category_data.category_description }}
                </b-card-text>

                <button v-on:click="triggerEdit">Edit</button>
            </b-card>

        </div>
        <div v-else>
            <b-card :title="category_data.category" sub-title=" ">
                <b-card-text>
                    <b>Name:</b> <b-input v-model="category_data.category" :value="category_data.category"></b-input>
                </b-card-text>

                <b-card-text>
                    <b>Time Added:</b> {{ category_data.ts || new Date() }}
                </b-card-text>

                <b-card-text>
                    <b>Description:</b> <b-input v-model="category_data.category_description" :value="category_data.category_description"></b-input>
                </b-card-text>

                <div v-if="category_data.id">
                    <button v-on:click="cancelEdit">Cancel</button>
                    <button v-on:click="updateEdit">Update</button>
                </div>
                <div v-else>
                    <button v-on:click="addNew">Add</button>
                </div>
            </b-card>
        </div>

    </div> -->
</template>
<script>
    
    export default {
        name: "Availability",
        components: {},
        props: ["viewdata", "locationsdict", "sublocationsdict"],
        data: function(){
            return {
                availability_data: [],
                product_id: null,
                product_sku: null,
            }
        },
        methods: {},
        created: function(){
            let viewdata = JSON.parse(JSON.stringify(this.viewdata)); 
            this.availability_data = viewdata.availability_data;
            this.product_id = viewdata.product_id;
            this.product_sku = viewdata.product_sku;
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/importables/Availability.vue